import React from 'react';
import '../Styles/styles.css';

const About = () => {
  return (
    <section id="about" className="about">
      <div className="container" data-aos="fade-up">

        <div className="section-title">
          <h2>About Us</h2>
        </div>

        <div className="row content">
          <div className="col-lg-6">
            <h3>Welcome to MultiMedia Computer Systems</h3>
            <p>
              At MMCS, we are dedicated to developing cutting-edge commercial software solutions that streamline
              document management and workflow automation. With a strong focus on industries such as Banking,
              Insurance, and professional services—including Auditors, Doctors, and Lawyers—our products are
              designed to enhance operational efficiency and drive digital transformation.
            </p>
            <h3>Our Mission</h3>
            <p>
              Our mission is to empower businesses and professionals with robust, scalable, and cost-effective
              software solutions. We aim to simplify complex business processes, enhance governance, and ensure
              compliance through our advanced technology frameworks. Our commitment to quality, security, and user
              experience positions us as a trusted partner in the digital landscape.
            </p>
          </div>
          <div className="col-lg-6 pt-4 pt-lg-0">
            <h3>Our Products</h3>
            <p>
              We offer three innovative products ready for the market:
            </p>
            <ul>
              <li>
                <strong>TRACE:</strong> A Governance, Risk, and Compliance (GRC) framework addressing the computational
                needs of audit professionals.
              </li>
              <li>
                <strong>EDICT:</strong> Helps in setting up Digital offices.
              </li>
              <li>
                <strong>CLACT:</strong> Cloud Accounting for small and medium enterprises.
              </li>
            </ul>
            <p>
              All products are available in both standard cloud (multi-tenancy) versions and customizable enterprise versions.
            </p>
            <h3>Market Potential</h3>
            <p>
              The demand for digital transformation solutions is immense, with a global customer base spanning millions of professionals.
              The target potential customer base across the world is huge—number of professionals run into millions!
            </p>
            <p>
              Join us in shaping the future of digital business solutions. Discover how MMCS can transform your operations today!
            </p>
            <a className="btn-learn-more">Learn More</a>
          </div>
        </div>

      </div>
    </section>
  )
}

export default About